/**
 * Validação de FORMATO de e-mail compartilhada pelo projeto.
 *
 * Regra pragmática e proposital: não é a RFC 5322 completa. Exige usuário,
 * domínio e TLD alfabético de 2+ letras — o bastante para barrar o lixo óbvio
 * (`a@b.c`, `a@b.c.`, `teste@dominio..com`) sem rejeitar endereço legítimo
 * comum. Os casos cobertos estão em `email.util.spec.ts`.
 *
 * Limitação aceita: acento/unicode no nome do usuário (`usuário@dominio.com`)
 * é rejeitado — raro no público do sistema, e o backend revalida com `@Email`.
 */
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;

/**
 * Diz se `email` tem formato válido.
 *
 * - Aplica `trim()` internamente: espaços colados junto do endereço (comum ao
 *   colar de outro app) não invalidam um e-mail bom.
 * - Retorna `false` para `null`/`undefined`/vazio. Quem decide se o campo é
 *   OBRIGATÓRIO é a tela — esta função só responde sobre FORMATO.
 *
 * @param email Valor digitado pelo usuário.
 * @returns `true` quando o formato é válido.
 */
export function isEmailValido(email: string | null | undefined): boolean {
  const valor = (email || '').trim();
  if (!valor) {
    return false;
  }
  return EMAIL_REGEX.test(valor);
}
